import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDgQBug5ZvX5NWhaM3CKx_Z7pFYKsb-mmE",
  authDomain: "invoicing-swg.firebaseapp.com",
  projectId: "invoicing-swg",
  storageBucket: "invoicing-swg.firebasestorage.app",
  messagingSenderId: "489183455593",
  appId: "1:489183455593:web:a152d73409aceec94035f8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};